import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { CommonBaseContent } from '../Layouts/CommonBackContent';
import { useTranslation } from 'next-i18next';
import styles from './index.module.less';
import { getStartDataListApi } from '@/lib/service';
import { Pagination, Tooltip } from 'antd';
import dynamic from 'next/dynamic';
import { FilterType } from './startCategorizeButton/filterPopover';
import Image from 'next/image';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import { CaretDownOutlined } from '@ant-design/icons';

const StarDataItem = dynamic(() => import('./startDataItem/index'), { ssr: true });
const EmptyData = dynamic(() => import('./emptyData/EmptyData'), { ssr: false });
const StartCateegorizeButton = dynamic(() => import('./startCategorizeButton'), { ssr: true });
const BestTipsContent = dynamic(() => import('../LandingPage/BestTipsContent'), { ssr: true });

const StarData: React.FC<any> = ({ data }) => {
  const { t } = useTranslation('common');
  const [startData, setStartData] = useState(data?.StarDataList?.data || []);
  const router = useRouter();

  const [pageNumber, setPageNumber] = useState(1);
  const [pageTotal, setPageTotal] = useState(data?.StarDataList?.total || 0);
  const [searchName, setSearchName] = useState('');

  const [order_column, setOrder_column] = useState(FilterType.FOLLOWING_HOT);

  const blogList1 = useMemo(() => {
    return [
      {
        title: 'Top Celebrity Influencers Connecting With Fans on Instagram',
        title_id: 'top-celebrity-influencers-connecting-with-fans-on-instagram',
        cover_image: 'https://res-back.pumpsoul.com/e7f158e3bc73406b9d15cfbc6f3bebe6.png',
        date: '2024-05-13',
      },
      {
        title: "How to Track Top UK Celebrities' Instagram Activity Using Dolphin Radar",
        title_id: 'how-to-track-top-uk-celebrities-27-instagram-activity-using-dolphin-radar',
        cover_image: 'https://res-back.pumpsoul.com/5fddc7b4c7f64f0d8a4245f8ecab44ee.png',
        date: '2024-06-12',
      },
      {
        title: 'Still Wondering How IG Trackers Can Keep You Closer to Celebrities?',
        title_id: 'still-wondering-how-ig-trackers-can-keep-you-closer-to-celebrities-3f',
        cover_image: 'https://res-back.pumpsoul.com/27c68b4f20804e85b2cff4c86da42412.png',
        date: '2024-09-23',
      },
      {
        title: 'Why track a celebrity’s Instagram account?',
        title_id: 'why-track-a-celebrity-e2-80-99s-instagram-account-3f',
        cover_image: 'https://res-back.pumpsoul.com/857974d50e59414a9132d70c5c68c7fd.png',
        date: '2024-05-21',
      },
    ];
  }, []);

  const blogList2 = useMemo(() => {
    return [
      {
        title: "Maximizing Your Brand's Reach: Partnering with Instagram Influencers",
        title_id: 'maximizing-your-brand-27s-reach-3a-partnering-with-instagram-influencers',
        cover_image: 'https://res-back.pumpsoul.com/bf6708673c22444ea61af47e2fdd65ec.jpg',
        date: '2024-10-15',
      },
      {
        title: 'Tracking Celebrities Who Are Military Veterans',
        title_id: 'tracking-celebrities-who-are-military-veterans',
        cover_image: 'https://res-back.pumpsoul.com/081859433b4341c0bfb95bc2e24082d1.png',
        date: '2024-05-28',
      },
      {
        title: '5 Celebrities You Won’t Believe Are Behind Bars — and What Landed Them There',
        title_id: '5-celebrities-you-won-e2-80-99t-believe-are-behind-bars-e2-80-94-and-what-landed-them-there',
        cover_image: 'https://res-back.pumpsoul.com/18d5e28ca92548898ffa1c8f885927f3.PNG',
        date: '2024-08-23',
      },
      {
        title: 'How to Track a Celebrity’s Instagram Activity',
        title_id: 'how-to-track-a-celebrity-e2-80-99s-instagram-activity',
        cover_image: 'https://res-back.pumpsoul.com/253e3f3f75e14363ae7ab4741c8f03e5.png',
        date: '2024-06-21',
      },
      {
        title: 'Unlock the Secrets of Celebrity Instagram Activity',
        title_id: 'unlock-the-secrets-of-celebrity-instagram-activity',
        cover_image: 'https://res-back.pumpsoul.com/bd50f0b193974a6f9523e871ffcfb06b.PNG',
        date: '2024-08-27',
      },
      {
        title: 'The Ultimate Instagram Tracker: Unlock Celeb Secrets for Fans, Paparazzi, and Media',
        title_id: 'the-ultimate-instagram-tracker-3a-unlock-celeb-secrets-for-fans-2c-paparazzi-2c-and-c2-a0media',
        cover_image: 'https://res-back.pumpsoul.com/03c7f79c0da64b6782439246165210f7.PNG',
        date: '2024-07-19',
      },
      {
        title: "The Celebrity Instagram Tracker: Who's Hot and What They're Posting",
        title_id: "the-celebrity-instagram-tracker-who's-hot-and-what-they're-posting",
        cover_image: 'https://res-back.pumpsoul.com/f4f2012d5c7b43a9bdd01c2b31d80d11.png',
        date: '2024-10-28',
      },
      {
        title: "How to Stay Updated on an Celebrity's Instagram Activity",
        title_id: 'how-to-stay-updated-on-an-celebrity-27s-instagram-activity',
        cover_image: 'https://res-back.pumpsoul.com/e7e16ff3c1d44d658f9b6d4683e20fb6.jpg',
        date: '2024-09-23',
      },
    ];
  }, []);

  const handleSearch = () => {
    getStartDataListApi(
      {
        page_no: pageNumber,
        page_size: 30,
        search_word: searchName,
        order_column,
        label: router?.query?.label,
      },
      data.locale
    ).then((res: any) => {
      if (res.code == 0) {
        setStartData(res.data);
        setPageTotal(res.total);
      }
    });
  };

  useEffect(() => {
    handleSearch();
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      handleSearch();
    } else {
      setPageNumber((prev) => 1);
    }
  }, [order_column, router?.query?.label]);

  const list = useMemo(() => {
    return [
      {
        title: t('Hottest'),
        img: '/images/starInfo/hot-icon.webp',
        searchKey: FilterType.FOLLOWING_HOT,
      },
      {
        title: t('Latest'),
        img: '/images/starInfo/new-icon.webp',
        searchKey: FilterType.FOLLOWER_LATEST,
      },
      {
        title: t('Most Followers'),
        searchKey: FilterType.FOLLOWER_NUM,
      },
      {
        title: t('Most Posts'),
        searchKey: FilterType.POST_NUM,
      },
      {
        title: t('Most Following'),
        searchKey: FilterType.FOLLOWING_NUM,
      },
    ];
  }, []);

  const getContentList = useCallback(() => {
    return startData?.length > 0 ? (
      <div className={styles.listCon}>
        {startData?.map((item: any, idx: number) => (
          <StarDataItem item={item} pageNumber={pageNumber} idx={idx} key={`${idx}-${item?.media_name}`} />
        ))}
      </div>
    ) : (
      <EmptyData searchStr={searchName}></EmptyData>
    );
  }, [startData, pageNumber, searchName]);

  const getPaginationContent = useCallback(() => {
    return startData?.length > 0 ? (
      <div className={styles.Pagination}>
        <Pagination
          current={pageNumber}
          showSizeChanger={false}
          defaultPageSize={30}
          onChange={(e) => {
            setSearchName('');
            setPageNumber(e);
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            });
          }}
          total={pageTotal}
        />
      </div>
    ) : (
      <></>
    );
  }, [startData, pageNumber, pageTotal, setPageNumber]);

  const items = () => {
    return (
      <>
        {list.slice(2, 5).map((item, index) => {
          return (
            <div
              key={item.title}
              className={styles.sortItem}
              onClick={(e) => {
                e?.stopPropagation();
                setOrder_column(item?.searchKey);
              }}
            >
              <span
                style={{
                  color: item.searchKey === order_column ? '#725CFF' : 'var(--app-text-color)',
                  cursor: 'pointer',
                  padding: '3px 5px',
                  display: 'inline-block',
                }}
              >
                {item?.title}
              </span>
            </div>
          );
        })}
      </>
    );
  };

  return (
    <div className={styles.backContent} style={{ minHeight: '100vh' }}>
      <CommonBaseContent>
        {/* {getHeader()} */}

        <h1 style={{ display: 'none', width: 0, height: 0 }}>
          {t('Track Instagram Follower Count Changes for xxx1 Celebrities').replace('xxx1', data?.count ?? '-')}
        </h1>

        <div className={styles.container}>
          <div
            className={styles.title}
            dangerouslySetInnerHTML={{
              __html: t('Track Instagram Follower Count Changes for xxx1 Celebrities').replace(
                'xxx1',
                `<span style="color: #4CC9FF;">${data?.count ?? '-'}</span>`
              ),
            }}
          />
          <div className={styles.desc}>
            <p>
              {t(
                'Track Instagram Follower Count for celebrities and influencers with Dolphin Radar. See how follower count changes after viral moments, collaborations, or breaking news, and gain insights into social influence and audience trends.'
              )}
              {` `}
              {t(
                'Only publicly available Instagram activity reports by Dolphin Radar are displayed here. Rest assured, your private tracking will not be shown.'
              )}
            </p>
          </div>
          <div className={styles.ipt}>
            <input
              type="text"
              value={searchName}
              onChange={(e: any) => {
                setSearchName(e.target.value);
              }}
              onBlur={(e) => {
                e.preventDefault(); // 阻止默认行为
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  // handleSearch();
                  if (pageNumber === 1) {
                    handleSearch();
                  } else {
                    setPageNumber(1);
                  }
                }
              }}
              placeholder={t("Enter the Instagram Username You're Interested In")}
            />
            <div
              onClick={() => {
                if (pageNumber === 1) {
                  handleSearch();
                } else {
                  setPageNumber(1);
                }
              }}
            >
              <img src="/images/home/glass.webp" alt="" />
            </div>
          </div>
          <div className={classNames([styles.sortList, styles.sortListPC])}>
            {list.map((item, index) => {
              return (
                <div
                  key={index}
                  className={classNames([
                    styles.sortItem,
                    item.searchKey === order_column ? styles.sortItemActive : '',
                  ])}
                  onClick={(e) => {
                    e?.stopPropagation();
                    setOrder_column(item?.searchKey);
                  }}
                >
                  {item.img && (
                    <Image src={item.img} alt={item.title} width={20} height={20} style={{ marginRight: '2px' }} />
                  )}
                  <span>{item?.title}</span>
                </div>
              );
            })}
          </div>
          <div className={classNames([styles.sortList, styles.sortListMobile])}>
            {list.slice(0, 2).map((item, index) => {
              return (
                <div
                  key={index}
                  className={classNames([
                    styles.sortItem,
                    item.searchKey === order_column ? styles.sortItemActive : '',
                  ])}
                  onClick={(e) => {
                    e?.stopPropagation();
                    setOrder_column(item?.searchKey);
                  }}
                >
                  {item.img && (
                    <Image src={item.img} alt={item.title} width={20} height={20} style={{ marginRight: '2px' }} />
                  )}
                  <span>{item?.title}</span>
                </div>
              );
            })}
            <Tooltip title={items} color={'#FFF'} placement="bottom" overlayStyle={{ zIndex: 1 }}>
              <div className={styles.sortItem}>
                <span>{t('More')}</span>
                <CaretDownOutlined style={{ marginLeft: '2px' }} />
              </div>
            </Tooltip>
          </div>
          <StartCateegorizeButton
            order_column={order_column}
            label={router?.query?.label as string}
            labelList={data?.labelList}
            onChangeFliterType={(val) => setOrder_column(val)}
          />
          {getContentList()}
          {getPaginationContent()}
        </div>

        <div style={{ marginBottom: '100px' }}>
          <BestTipsContent title={t('Must-Reads')} blogList={blogList1} />
          <BestTipsContent title={t('Latest Updates')} blogList={blogList2} />
        </div>
      </CommonBaseContent>
    </div>
  );
};

export default StarData;
